import {DumpsterFire} from "../DumpsterFire";
import {DFGameConfig} from "../DFGameConfig";
import {TimelineLite, gsap} from "gsap";
import {DumpsterFireSound} from "../sound/DumpsterFireSound";

export class DFXWaysView extends PIXI.Container {
    constructor() {
        super();
        this.name = "DFXWaysView";
    }

    public playXWaysAnimation(reelId: number, rowId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const anim: PIXI.spine.Spine = new PIXI.spine.Spine(DumpsterFire.assetLoader.getSpineAsset("XW"));
        anim.visible = true;
        anim.alpha = 0;
        anim.position.set(DFGameConfig.symbolWidth * reelId + 60, (DFGameConfig.symbolHeight * (rowId)) + 128)
        this.addChild(anim);
        tl.add([() => {
            gsap.to(anim, {duration: 0.2, alpha: 1});
        },
            DumpsterFire.createTimelineForAnimation(anim, 0, "active", false)]);
        tl.add(() => {
            this.removeChild(anim);
        }, ">");
        return tl;
    }
}